import request from '@/utils/request'
/**
 * @fileOverview 复评相关API
*/

/**
 * @description 复评作品分类列表
*/
export function getReReviewCategories() {
  // 检查当前路由是否为终评作品页面
  const isFinalReview = window.location.hash.includes('finalReview')
  
  return request({
    url: isFinalReview ? '/reviews/final' : '/reviews/nomination',
    method: 'get'
  })
}

/**
 * @description 复评作品列表
* @param {Object} params 查询参数
* @param {string} params.category_id 分类ID
* @param {string} params.search 搜索关键词
* @param {string} params.user_id 用户ID
* @param {string} params.page 页码
* @param {string} params.status 状态
*/
export function getReReviewProducts(params) {
  // 检查当前路由是否为终评作品页面
  const isFinalReview = window.location.hash.includes('finalReview')
  
  return request({
    url: isFinalReview ? '/reviews/lastProduct' : '/reviews/nominationProduct',
    method: 'get',
    params
  })
}

/**
 * @description 复评打分
* @param {string} id 作品ID
* @param {string} type 初评类型
* @param {Object} data 评分数据
* @param {number} data.score 评分
* @param {number} data.register_status 金奖提名状态
* @param {string} data.feedback 初评意见
*/
export function updateReReviewScore(id, type, data) {
  return request({
    url: `/reviews/product/${id}/${type}`,
    method: 'put',
    data
  })
}

/**
 * @description 获取复评作品详情
* @param {string} id 作品ID
* @param {string} user_id 用户ID
 * @param {string} type 初评类型
*/
export function getReReviewProduct(id, user_id, type) {
  return request({
    url: `/products/${id}`,
    method: 'get'
  })
}
